module.exports = __webpack_public_path__ + "img/tree-palm.06e68984.svg";